import { render, staticRenderFns } from "./ModalSertificate.vue?vue&type=template&id=5df8b7ea&scoped=true"
import script from "./ModalSertificate.vue?vue&type=script&lang=js"
export * from "./ModalSertificate.vue?vue&type=script&lang=js"
import style0 from "./ModalSertificate.vue?vue&type=style&index=0&id=5df8b7ea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8b7ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitrix/ext_www/igr.ru/local/templates/main/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5df8b7ea')) {
      api.createRecord('5df8b7ea', component.options)
    } else {
      api.reload('5df8b7ea', component.options)
    }
    module.hot.accept("./ModalSertificate.vue?vue&type=template&id=5df8b7ea&scoped=true", function () {
      api.rerender('5df8b7ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalSertificate.vue"
export default component.exports